import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthed, login } from './auth';
import './admin.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  React.useEffect(() => {
    if (isAuthed()) navigate('/admin');
  }, [navigate]);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (login(username, password)) {
      navigate('/admin');
    } else {
      setError('Geçersiz kullanıcı adı veya şifre');
    }
  };

  return (
    <div className="admin-login-wrap">
      <form className="admin-login-card" onSubmit={submit}>
        <h2>Admin Giriş</h2>
        <label>
          Username
          <input value={username} onChange={e => setUsername(e.target.value)} placeholder="admin" />
        </label>
        <label>
          Password
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="*********" />
        </label>
        {error && <div className="error">{error}</div>}
        <button type="submit" className="btn primary">Giriş Yap</button>
      </form>
    </div>
  );
};

export default LoginPage;
